import { createContext } from 'react';

export const CreateAccountContext = createContext({});
